export const CUSTOMER_ROLE = 0;
export const SUPPLIER_ROLE = 1;
export const CUSTOMER_ADMIN = 'CUSTOMER_ADMIN';
export const ORDER_LIST = 'ORDER_LIST'; 
export const REPORTING = 'REPORTING';

export const menuItems = [
    
    ///////////////////
    // Customer Menu 

    {
        id: 1,
        label: 'Accueil',
        icon: 'fas fa-home',
        withIcon: true,
        subItems:[],
        link: '/', 
        role:CUSTOMER_ROLE,
        
    },

   /* {
        id: 2,
        label: 'Ma Commande',
        icon: 'fas fa-chart-line ',
        subItems:[],
        link:"/ma-commande",
        role:CUSTOMER_ROLE,
    },*/
 

    ///////////////////
    // Supplier Menu 
    
    /*{
        id: 100,
        label: 'Accueil',
        subItems:[],
        link: '/',
        role:SUPPLIER_ROLE,
    },


    {
        id: 106,
        label: 'Commande',
        icon: 'fas fa-chart-line ',
        subItems:[],
        link:"/commande",
        role:SUPPLIER_ROLE,
    },

    {
        id: 103,
        label: 'Utilisateurs',
        link:'/utilisateurs',
        role:SUPPLIER_ROLE,
    
    },

    {
        id: 105,
        label: 'Système',
        icon: 'fas fa-bullhorn ',
        subItems:[],
        link:"/bannieres",
        role:SUPPLIER_ROLE,
    },*/




];

